import { PatientRelationship } from '@kyruus/provider-components';
import { ExtendedProvider, Profile } from 'Src/types';

export const convertProfilesToProviders = (
  profiles: Profile[],
  locationId: string
): ExtendedProvider[] => {
  return profiles.map((profile: Profile) => {
    const location = profile.locations?.find(
      (loc) => String(loc.primary_marketable_location_id) === String(locationId)
    );
    return {
      ...profile.provider,
      locations: location ? [location] : [],
      has_provider_availability: !!profile.availability?.slots?.length,
      has_provider_availability_new: !!profile.availability?.slots?.filter(
        (s) => s.patient_relationship === PatientRelationship.NEW
      )?.length,
      has_provider_availability_established:
        !!profile.availability?.slots?.filter(
          (s) => s.patient_relationship === PatientRelationship.ESTABLISHED
        )?.length
    };
  });
};
